import { BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
import { FormGroup, Validators } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ResenjeZaGo } from './resenje-za-go';
import { PodVrstaDokumentaStavkaView } from 'src/app/lookups/podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-resenje-za-go-update',
  templateUrl: './resenje-za-go-update.component.html'
})

export class ResenjeZaGoUpdateComponent
extends BaseUpdateComponent<ResenjeZaGo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('OsobaID', Validators.required, 'required', 'RESENJEZAGO.OSOBA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Godina', Validators.required, 'required', 'RESENJEZAGO.GODINA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Broj', Validators.required, 'required', 'RESENJEZAGO.BROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datum', Validators.required, 'required', 'RESENJEZAGO.DATUM.VALIDATION.REQUIRED');
    this.addValidatorToFc('PravoNaGoBrojDana', Validators.required, 'required', 'RESENJEZAGO.PRAVONAGOBROJDANA.VALIDATION.REQUIRED');  

    //this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'RESENJEZAGO.PRAVONAGOBROJDANA.VALIDATION.REQUIRED');   

    this.baseFormGroup.updateValueAndValidity();

    this.IDProcessed
    .subscribe((value) => {
      if (value && this.Item.ID==-1)
      {
        let dateNow = new Date();
        let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
        this.baseFormGroup.patchValue({ Datum: date });
        this.baseFormGroup.get('Datum').updateValueAndValidity();
      }
    })
  }

  onPodVrstaSelect(value: PodVrstaDokumentaStavkaView) {
    if (value != null){
      this.getBrojDokumenta();
      if(!this.modelData.MainList.LoadFormControlDataOnInit)        
        this.getFormControlData('kad/ResenjeZaGo', this.fc.PodVrstaDokumentaStavkaID.value)
    }
}

getBrojDokumenta() {
  let podvrstaid = this.baseFormGroup.get('PodvrstaDokumentaStavkaID').value;
  let datum = this.baseFormGroup.get('Datum').value;
  
  //Ako je podatak nov (zato ima ID -1) i ako podvrstaid i datum nisu NULL, nula ili false
  if (this.Item.ID == -1 && podvrstaid && datum)
  //Poziva se metoda KreirajBrojDokumenta iz controlera Yt_App.API\Controllers\KadControllers\ResenjeZaGoController
  //i prosleđuju se vrednosti toj metodi za podvrstaid i datum
      this.baseDataService.GetData('ResenjeZaGo','KreirajBrojDokumenta',{'PodvrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
        .subscribe(data => {
          //Kažemo kontroli Broj (sa HTMLa) koja je njena vrednost i update-ujemo vrednost kontrole
            this.baseFormGroup.patchValue({ Broj: data });
            this.baseFormGroup.get('Broj').updateValueAndValidity();
        })

}

  editMode: boolean = false;
  item: any;
}
